export enum ProjectionLevel {
    Overview,
    Precise,
    TrackingOverview,
    TrackingPrecise,
    TrackingDetailed,
    Events
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/projection-level.ts